export default "<div id=\"stepper\">\r\n    <div class=\"oval\"></div>\r\n    <div *ngIf=\"insertLine\" class=\"line\"></div>\r\n</div>"